import { org_revenue_path, revenue_path } from "@/lib/routes"
import type { Filters } from "./types"

type Query = Record<string, string | string[]>

/** Query params for the page: every control, so links are shareable. */
export function toQuery(filters: Filters, scopeSlug: string | null, currency: string | null = null): Query {
  const q: Query = {
    preset: filters.preset,
    grain: filters.grain,
    rows: filters.rows,
  }
  if (currency) q.currency = currency
  if (filters.preset === "custom") {
    q.from = filters.from
    q.to = filters.to
  }
  if (filters.sort) {
    q.sort = filters.sort
    q.dir = filters.dir
  }
  if (scopeSlug) q.scope = scopeSlug
  if (filters.products.length > 0) q.products = filters.products
  return q
}

function withQuery(path: string, query: Query): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(query)) {
    if (Array.isArray(value)) value.forEach((v) => params.append(`${key}[]`, v))
    else params.set(key, value)
  }
  return `${path}?${params.toString()}`
}

/** Plain href (for <Link>s and menus) with Rails-style `products[]` arrays. */
export function hrefFor(marketSlug: string, filters: Filters, scopeSlug: string | null): string {
  return withQuery(revenue_path(marketSlug), toQuery(filters, scopeSlug))
}

/** All-markets page href; the display currency rides along like any other control. */
export function overviewHrefFor(filters: Filters, currency: string | null): string {
  return withQuery(org_revenue_path(), toQuery(filters, null, currency))
}
